// Class: haxe.ds._List.ListNode

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../hxClasses_stub").default;
var $hxEnums = require("./../../../hxEnums_stub").default;

// Constructor

var ListNode = function(item,next) {
	this.item = item;
	this.next = next;
}

// Meta

ListNode.__name__ = "haxe.ds._List.ListNode";
ListNode.__isInterface__ = false;
ListNode.prototype = {
	
};
ListNode.prototype.__class__ = ListNode.prototype.constructor = $hxClasses["haxe.ds._List.ListNode"] = ListNode;

// Init



// Statics




// Export

exports.default = ListNode;